import { render, staticRenderFns } from "./AssessmentReport.vue?vue&type=template&id=1ad65a08&scoped=true&"
import script from "./AssessmentReport.vue?vue&type=script&lang=js&"
export * from "./AssessmentReport.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentReport.vue?vue&type=style&index=0&id=1ad65a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad65a08",
  null
  
)

export default component.exports